module.exports = __webpack_public_path__ + "img/amparo.2539f9a8.png";